import { fetchJournals } from './fetchJournals'

export const normalizeJournalsData = ({
  journalsData
}: {
  journalsData: Awaited<ReturnType<typeof fetchJournals>>
}) => {
  const journalsDataNormalized = journalsData?.data?.map(
    ({
      name,
      description,
      slug,
      createdDate,
      time,
      image,
      // category,
      tag
      // faculty
    }) => ({
      name: name || null,
      description: description || null,
      slug: slug || null,
      createdDate: createdDate?.slice(0, 10) || null,
      time: time || null,

      image: image
        ? {
            width: image.width || null,
            height: image.height || null,
            url: image.url || null,
            alternativeText: image.alternativeText || null
          }
        : null,

      // category: category
      //   ? {
      //       name: category.name || null,
      //       slug: category.slug || null
      //     }
      //   : null,

      tag: tag
        ? {
            name: tag.name || null,
            slug: tag.slug || null,
            color: tag.color || null,
            tagImage: tag.tagImage
              ? {
                  width: tag.tagImage.width || null,
                  height: tag.tagImage.height || null,
                  url: tag.tagImage.url || null,
                  alternativeText: tag.tagImage.alternativeText || null
                }
              : null
          }
        : null

      // faculty: faculty
      //   ? {
      //       name: faculty.name || null,
      //       slug: faculty.slug || null,
      //       color: faculty.color || null,
      //       tagImage: faculty.tagImage
      //         ? {
      //             width: faculty.tagImage.width || null,
      //             height: faculty.tagImage.height || null,
      //             url: faculty.tagImage.url || null,
      //             alternativeText: faculty.tagImage.alternativeText || null
      //           }
      //         : null
      //     }
      //   : null
    })
  )

  return {
    data: journalsDataNormalized?.length ? journalsDataNormalized : null,
    total: journalsData?.total ?? 0
  }
}
